<div class="login-body">

  <div class="flex-row">
    <div class="flex-column"></div>
    <div class="flex-column-main">
      <app-login-brand></app-login-brand>
      <form [formGroup]="frmSignup" novalidate>
        <div class="form-group" [ngClass]="{ 'has-error': submitted && f.email.errors }">
          <input id="email" type="text" placeholder="Email" formControlName="email" class="form-control" [ngClass]="(submitted && f.email.invalid) ? 'is-invalid' : ''" />
          @if (submitted &&  f.email.hasError('required')) {
            <label>
              Email is Required!
            </label>
          }
          @if (f.email.value && f.email.hasError('email')) {
            <label>
              Enter a valid email address!
            </label>
          }
        </div>
        <div class="form-group" id="divforgotPassword">
          <button class="btn-outline-light btn-lg" (click)="sendPasswordLink()">Submit</button>
        </div>
      </form>
    </div>
    <div class="flex-column"></div>
  </div>
</div>
